import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CruiseeventbyevtcodeService {
  OBPortalSvcURL = '';

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public GetCruiseEventByevtCode(
    creevtCode: string | undefined
  ): Observable<any> {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    const CruiseEventInfo: JSON = <JSON>(<unknown>{
      creevtCode: creevtCode,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.OBPortalSvcURL + 'GetCruiseEventByevtCode',
      JSON.stringify(CruiseEventInfo),
      { headers: headers }
    );
  }
}
